var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 1.75L1.25 8L7.5 14.25","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Arrow.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
